import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const faqItems = [
  { qKey: 'faq.q1', aKey: 'faq.a1' },
  { qKey: 'faq.q2', aKey: 'faq.a2' },
  { qKey: 'faq.q3', aKey: 'faq.a3' },
  { qKey: 'faq.q4', aKey: 'faq.a4' },
];

export default function FaqSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100">
      <div className="mx-auto max-w-4xl px-4 md:px-6 py-16 md:py-24">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            {t('faq.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">{t('faq.subtitle')}</p>
        </div>

        <div className="mt-10 space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.qKey}
                className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {t(item.qKey)}
                  </span>
                  <span className="flex w-6 h-6 items-center justify-center text-foreground-500 shrink-0">
                    <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-lg transition-transform`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{t(item.aKey)}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}